<div
  class="loader"
  [ngClass]="{
    'loader--small': size && size == 'small',
    'loader--without-position': position == 'reset'
  }"
>
  <svg width="34px" height="34px" viewBox="0 0 34 34" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 46 (44423) - http://www.bohemiancoding.com/sketch -->
    <title>loader</title>

    <defs>
      <linearGradient x1="90.0460379%" y1="0%" x2="17.2572545%" y2="89.9623326%" id="LoaderGradient1">
        <stop stop-color="#FBE027" offset="0%"></stop>
        <stop stop-color="#F2AA2E" offset="100%"></stop>
      </linearGradient>
    </defs>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g fill-rule="nonzero">
        <path
          d="M17,34 C7.61115925,34 0,26.3888407 0,17 C0,7.61115925 7.61115925,0 17,0 C26.3888407,0 34,7.61115925 34,17 C34,26.3888407 26.3888407,34 17,34 Z M17,28 C23.0751322,28 28,23.0751322 28,17 C28,10.9248678 23.0751322,6 17,6 C10.9248678,6 6,10.9248678 6,17 C6,23.0751322 10.9248678,28 17,28 Z"
          fill="#BABBB6"
        ></path>
        <path
          d="M24.5608636,32.2295288 C30.2947776,29.3783468 34,23.5200868 34,17 C34,7.61115925 26.3888407,0 17,0 C7.61115925,0 0,7.61115925 0,17 C0,18.6568542 1.34314575,20 3,20 C4.65685425,20 6,18.6568542 6,17 C6,10.9248678 10.9248678,6 17,6 C23.0751322,6 28,10.9248678 28,17 C28,21.2207896 25.6031413,25.0104194 21.889413,26.8570665 C20.4058485,27.5947672 19.8012064,29.3954584 20.5389071,30.8790229 C21.2766078,32.3625874 23.0772991,32.9672295 24.5608636,32.2295288 Z"
          fill="url(#LoaderGradient1)"
        ></path>
      </g>
    </g>
  </svg>
</div>
